export default __webpack_public_path__ + "static/media/health-data-icon.beaff02a.svg";